import React from "react";

import AppPage from "@/ui/AppPage/AppPage";
import MainMap from "@/views/GIS/MapPage/MainMap";

import { Permissions } from "@/lib/permissions";

import MapRoutingProvider from "@/components/MapRoutingContext/MapRoutingProvider";

function RegUserMapPage() {

  return (
    <AppPage needPermission={[Permissions.UserEdit]}>
      <MapRoutingProvider>
        <MainMap mapId={100} />
      </MapRoutingProvider>
    </AppPage>
  );
}

export default RegUserMapPage;
